import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import { DEVICE_STATE_LABEL, DEVICE_STATE_TONE, DeviceState } from '../../Enums/device-state.enum';
import {
  DeviceCollectedDataResponse,
  DeviceDetailResponse,
  DeviceLicenceResponse,
} from '../../Interfaces/api/backoffice/device.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class DeviceDetail {
  id = '';
  name: string | null = null;
  azureADDeviceId: string | null = null;
  organization_id: string | null = null;
  last_seen_at: string | null = null;
  inactivity_reference: string | null = null;
  state = '';
  is_inactive = false;
  is_provisioned = false;
  created_at: string | null = null;
  deleted_at: string | null = null;
  licence: DeviceLicenceResponse | null = null;
  report_count = 0;
  last_report_at: string | null = null;
  collected_data: DeviceCollectedDataResponse | null = null;

  constructor(data: Partial<DeviceDetailResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.azureADDeviceId || this.id;
  }

  get stateLabelKey(): string {
    return DEVICE_STATE_LABEL[this.state] ?? this.state;
  }

  get stateTone(): StatusTone {
    return DEVICE_STATE_TONE[this.state] ?? 'neutral';
  }

  get isRetired(): boolean {
    return this.state === DeviceState.RETIRED;
  }

  get osVersion(): string {
    return this.collected_data?.os?.version || VALUE_UNRESOLVED;
  }

  get osCaption(): string {
    return this.collected_data?.os?.caption || VALUE_UNRESOLVED;
  }

  get biosVersion(): string {
    return this.collected_data?.bios?.version || VALUE_UNRESOLVED;
  }

  get hasCollectedData(): boolean {
    return this.collected_data !== null && Object.keys(this.collected_data).length > 0;
  }

  get collectedJson(): string {
    return this.collected_data === null ? '' : JSON.stringify(this.collected_data, null, 2);
  }
}
